import { themesCacheKeys } from '@rockalingua/shared/themes/constants';
import axios from '@/api/axiosInstance';

export default async function getThemes(includeActivities = false) {
  const urlName = includeActivities
    ? themesCacheKeys.themesWithActivities
    : themesCacheKeys.themes;
  let response = null;
  try {
    response = await axios({
      method: 'get',
      url: getThemesCacheUrl(urlName),
      params: { v: await getThemesCacheVersion() },
    });
  } catch (e) {
    response = await axios({
      method: 'get',
      url: `${
        process.env.API || process.env.NEXT_PUBLIC_API
      }/themes?includeActivities=${includeActivities}`,
    });
  }
  return response.data;
}

async function getThemesCacheVersion() {
  try {
    const response = await axios({
      method: 'get',
      url: getThemesCacheUrl(themesCacheKeys.version),
      params: { v: Date.now() },
    });
    return response.data.version;
  } catch (e) {
    return Date.now();
  }
}

function getThemesCacheUrl(urlName) {
  const suffix = process.env.NEXT_PUBLIC_THEME_CACHE_SUFFIX || '';
  return `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/cache/${process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT}/${urlName}${suffix}.json`;
}
